/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiServer } from '../../models/AaiServer';
import { Node } from '../../../core/models/Node';
import { Server } from '../../../core/models/common/Server';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends AaiServer
 * @author eric.wittmann@gmail.com
 */
export class Aai20Server extends AaiServer {
    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super(parent, name);
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super(name);
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && name === undefined) {
            let __args = arguments;
            super(parent);
        } else throw new Error('invalid overload');
    }

    /**
     * @see Server#createServerVariable(String)
     * @param {string} name
     * @return {Aai20ServerVariable}
     */
    public createServerVariable(name : string) : Aai20ServerVariable {
        return new Aai20ServerVariable(this, name);
    }

    /**
     * Creates a security requirement.
     * @return {Aai20SecurityRequirement}
     */
    public createSecurityRequirement() : Aai20SecurityRequirement {
        return new Aai20SecurityRequirement(this);
    }
}
Aai20Server["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20Server";
Aai20Server["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.INamed"];





import { Aai20SecurityRequirement } from './Aai20SecurityRequirement';


import { Aai20ServerVariable } from './Aai20ServerVariable';

